/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css } from 'aphrodite';
import { fonts, mixins } from '@blend/consumer-components';
import { GenerateStyles, useConsumerTheme } from '../../../../hooks/useConsumerTheme';
import { useMobileDocSubheaderText } from './hooks/useMobileDocSubheaderText';

export namespace MobileDocSubheader {
  export interface Props {}
}

const fontSize = 16;
const verticalPadding = 12;
const boxShadowOffsetY = 2;
const boxShadowBlur = 4;
export const mobileDocSubheaderHeight = verticalPadding * 2 + fontSize + boxShadowOffsetY + boxShadowBlur;

const generateStyles: GenerateStyles = ({ colors }) => ({
  mobileDocSubheader: {
    fontSize,
    fontWeight: 500,
    ...fonts.UntitledSans,
    ...mixins.margin(0, 8),
    ...mixins.padding(verticalPadding, 24),
    textAlign: 'center',
    boxShadow: `0px ${boxShadowOffsetY}px ${boxShadowBlur}px 0px`,
    borderRadius: '0px 0px 4px 4px',
    flexGrow: 1,
  },
  info: {
    color: colors.reflex,
    background: colors.reflexLight08,
  },
  affirm: {
    color: colors.catalyst,
    background: colors.catalystLight03,
  },
  void: {
    color: colors.pinkDark33,
    background: colors.pinkLight08,
  },
  none: {
    ...mixins.padding(0), // to hide subheader when signing has not begun
  },
});

export const MobileDocSubheader: React.FC<MobileDocSubheader.Props> = () => {
  const { styles } = useConsumerTheme(generateStyles);
  const mobileDocSubheaderText = useMobileDocSubheaderText();

  let indicatorType = 'info';
  if (mobileDocSubheaderText === 'This document has been completed') {
    indicatorType = 'affirm';
  } else if (mobileDocSubheaderText === 'This document has been voided') {
    indicatorType = 'void';
  } else if (mobileDocSubheaderText === null) {
    indicatorType = 'none';
  }

  return (
    <div className={css(styles.mobileDocSubheader, (styles as any)[indicatorType])} data-it="MobileDocSubheader">
      {mobileDocSubheaderText}
    </div>
  );
};
